import { Modal, Text } from '@opengov/component-library/dist';
import { AGGREGATE } from '@opengov/reporting-types/src/reportColumns';
import { ISavedView } from '@opengov/reporting-types/src/reportSavedView';

import React from 'react';
import { NavigateFunction } from 'react-router-dom';

import { IReportLocale } from '../../../../common/locale';
import { SavedViewFormFields } from '../savedViewForm/SavedViewFormFields';
import { ISavedViewTitleAndDescription, useSavedViewForm } from '../savedViewForm/useSavedViewForm';

import styles from './SavedViewCreatingModal.scss';

export type { ISavedViewTitleAndDescription };

export interface ISavedViewCreatingModal {
  categorizedBy: string;
  organizedBy: string;
  reportLocaleText: IReportLocale;
  showColumnName: string;
  existingSavedViews?: ISavedView[];
  onClose(): void;
  onCreate(savedView: ISavedViewTitleAndDescription, navigate: NavigateFunction): void;
}

export const SavedViewCreatingModal = (props: ISavedViewCreatingModal) => {
  const form = useSavedViewForm(props.existingSavedViews);

  const handleCreate = () => {
    props.onCreate({ title: form.title, description: form.description }, form.navigate);
  };

  const {
    showColumnName,
    categorizedBy,
    onClose,
    organizedBy,
    reportLocaleText: {
      cancel,
      description,
      reportExplorer: {
        controls: { aggregate }
      },
      savedView: {
        enterViewName,
        modal: {
          createView,
          titleDuplicate,
          titlePlaceHolder,
          showingByCategorizedBy: { by, showing, categorized }
        }
      }
    }
  } = props;

  return (
    <Modal.Work title={props.reportLocaleText.savedView.modal.title} onClose={onClose}>
      <div className={styles.borders}>
        <Text size="small">
          {showing} <strong>{showColumnName} </strong>
          {by} <strong>{organizedBy} </strong>
          {categorized} <strong>{categorizedBy === AGGREGATE ? aggregate : categorizedBy} </strong>
        </Text>
        <br />
        <SavedViewFormFields
          form={form}
          localeText={{ cancel, createView, description, enterViewName, titleDuplicate, titlePlaceHolder }}
          onClose={onClose}
          onSubmit={handleCreate}
        />
      </div>
    </Modal.Work>
  );
};
